import {Component, OnInit, OnDestroy, ViewChild} from '@angular/core';
import {MessageService} from '../message.service';
import {Router} from '@angular/router';
import {NgbModal, ModalDismissReasons, NgbModalRef} from '@ng-bootstrap/ng-bootstrap';

import {Column, GridOption, AngularGridInstance, Formatters, OnEventArgs} from 'angular-slickgrid';
import {CustomInputEditor} from '../custom-inputEditor';
import {NotifierService} from 'angular-notifier';
import {RestApiService} from '../rest-api.service';
import {Subscription} from 'rxjs';
import {FormControl} from '@angular/forms';


@Component({
    selector: 'app-ticket-flow-status',
    templateUrl: './ticket-flow-status.component.html',
    styleUrls: ['./ticket-flow-status.component.css']
})

export class TicketFlowStatusComponent implements OnInit, OnDestroy {
    description: string;
    clientId: number;
    status = [];
    statusSelected: number;
    nextStatusSelected: any;
    ttypes = [];
    ticketSelected: number;
    ticketTypeId: number;
    categoryLoaded: boolean;
    private baseCategories = [];
    ticketTypes: any;
    cat = [];
    dynamicFields = [];
    priorityType: number;
    columnDefinitions = [];
    ticketType: string;
    ticketTypeSeqNo: number;
    ticket_status = [];
    ststusSelected: number;
    ticketStatus: string;
    status_sequence: number;

    add: boolean;
    del: boolean;
    edit: boolean;
    view: boolean;
    displayData: any;

    isError = false;
    errorMessage: string;
    respObject: any;
    totalData: number;
    nextOffset: number;
    previousOffset: number;
    pageSize: number;
    paginationType: string;
    page_no: number;
    totalPage: number;
    private baseFlag: any;
    private userAuth: Subscription;
    private notifier: NotifierService;
    offset: number;
    // types = [];
    typeSelected: number;
    ticketFieldTicketName = '';
    isDropdown: boolean;
    dropdown = '';
    isCategory: boolean;
    isStatus: boolean;
    dataLoaded: boolean;
    statusSeq = [];
    showSearch = true;
    isLoading = false;
    searchData: FormControl = new FormControl();
    statusSelect: any;
    statuses: any;
    nxt: string;
    selectedId: number;
    @ViewChild('content1') private content1;
    private modalReference: NgbModalRef;
    nextStatus: string;
    @ViewChild('scarch_content') private scarch_content;
    private searchModalReference: NgbModalRef;



    constructor(private _rest: RestApiService, private messageService: MessageService, private route: Router,
                private modalService: NgbModal, notifier: NotifierService) {
        this.notifier = notifier;
        this.messageService.getCellChangeData().subscribe(item => {
            // console.log(item);
            switch (item.type) {
                case 'change':
                    if (!this.messageService.edit) {
                        this.notifier.notify('error', 'You do not have edit permission');
                    } else {
                    }
                    break;
                case 'delete':
                    // console.log('deleted');
                    if (!this.messageService.del) {
                        this.notifier.notify('error', 'You do not have delete permission');
                    } else {
                        if (confirm('Are you sure?')) {
                            // console.log(JSON.stringify(item));
                            this._rest.deleteStatusSeq({id: item.id, user_id: this.messageService.getUserId()}).subscribe((res) => {
                                this.respObject = res;
                                if (this.respObject.success) {
                                    this.messageService.sendAfterDelete(item.id);
                                } else {
                                    this.notifier.notify('error', this.respObject.errorMessage);
                                }
                            }, (err) => {
                                this.notifier.notify('error', JSON.stringify(err));
                            });
                        }
                    }
                    break;
            }
        });
    }

    ngOnInit() {
        this.dataLoaded = false;
        this.isCategory = false;
        this.isStatus = false;
        this.description = '';
        this.categoryLoaded = true;
        this.ticketSelected = 0;
        this.nextOffset = 0;
        this.previousOffset = 0;
        this.pageSize = this.messageService.pageSize;
        this.page_no = 0;
        this.totalPage = 0;
        this.displayData = {
            pageName: 'Maintain Status Sequence',
            openModalButton: 'Add Status Sequence',
            searchModalButton: 'Search',
            breadcrumb: 'Status Sequence',
            folderName: 'All Status',
            tabName: 'Status Sequence'
        };
        this.typeSelected = 1;
        this.columnDefinitions = [
            {
                id: 'delete',
                field: 'id',
                excludeFromHeaderMenu: true,
                formatter: Formatters.deleteIcon,
                minWidth: 30,
                maxWidth: 30,
            },
            {
                id: 'edit',
                field: 'id',
                excludeFromHeaderMenu: true,
                formatter: Formatters.editIcon,
                minWidth: 30,
                maxWidth: 30,
                onCellClick: (e: Event, args: OnEventArgs) => {
                    this.selectedId = args.dataContext.id;
                    this.ticketSelected = args.dataContext.ticket_type_id;
                    this.statusSelected = args.dataContext.ticket_pres_status_id;
                    this.nextStatus = args.dataContext.ticket_nxt_status_id;
                    const nextStatusArr = this.nextStatus.split(',');
                    for (let i = 0; i < this.statusSeq.length; i++) {
                        const n = nextStatusArr.indexOf(String(this.statusSeq[i].id));
                        if (n >= 0) {
                            this.statusSeq[i].checked = true;
                        }
                    }
                    this.modalReference = this.modalService.open(this.content1,{size: 'sm'});
                    this.modalReference.result.then((result) => {
                    }, (reason) => {

                    });
                }
            },
            {
                id: 'ticketType', name: 'Ticket Type', field: 'ATTRVAL', sortable: true, filterable: true, width: 40
            },
            {
                id: 'previd', name: 'Status', field: 'previd', sortable: true, filterable: true, width: 130
            },
            {id: 'nextid', name: 'Next Status', field: 'nextid', sortable: true, filterable: true}
        ];
        this.messageService.setColumnDefinitions(this.columnDefinitions);
        if (this.messageService.clientId) {
            this.clientId = this.messageService.clientId;
            this.baseFlag = this.messageService.baseFlag;
            this.onPageLoad();
        } else {
            this.userAuth = this.messageService.getClientUserAuth().subscribe(auth => {
                this.view = auth[0].viewFlag;
                this.add = auth[0].addFlag;
                this.edit = auth[0].editFlag;
                this.del = auth[0].deleteFlag;
                this.clientId = auth[0].clientId;
                this.baseFlag = auth[0].baseFlag;
                this.onPageLoad();
            });
        }
    }

    onPageLoad() {
        this._rest.getTicketType(this.clientId).subscribe((res1) => {
            this.respObject = res1;
            if (this.respObject.success) {
                this.isError = false;
                this.respObject.details.unshift({id: 0, name: 'Select Ticket Type'});
                this.ttypes = this.respObject.details;
                this.ticketSelected = 0;
            } else {
                this.notifier.notify('error', this.respObject.errorMessage);
            }
        }, (err) => {
            this.notifier.notify('error', JSON.stringify(err));
        });
        this.getTableData();

        this._rest.getStatusForClient(this.clientId).subscribe((res2) => {
            this.respObject = res2;
            if (this.respObject.success) {
                this.isError = false;
                this.respObject.details.unshift({id: 0, name: 'Select Status Seq'});
                this.status = this.respObject.details;
                this.statusSelected = 0;
            } else {
                this.notifier.notify('error', this.respObject.errorMessage);
            }
        }, (err) => {
            this.notifier.notify('error', JSON.stringify(err));
        });

        this._rest.getStatusForClient(this.clientId).subscribe((res2) => {
            this.respObject = res2;
            if (this.respObject.success) {
                this.isError = false;
                this.statusSeq = this.respObject.details;
                this.statusSelected = 0;
            } else {
                this.notifier.notify('error', this.respObject.errorMessage);
            }
        }, (err) => {
            this.notifier.notify('error', JSON.stringify(err));
        });

        this.getTableData();
    }

    changeRouting(path: string) {
        this.messageService.changeRouting(path);
    }

    openModal(content) {
        if (!this.messageService.add) {
            this.notifier.notify('error', 'You do not have add permission');
        } else {
            this.description = '';
            this.ticketTypes = [];
            this.ticketSelected = 0;
            this.statusSelected = 0;
            for (let i = 0; i < this.statusSeq.length; i++) {
                    this.statusSeq[i].checked = false;
            }
            this.modalService.open(content, {size: 'sm'}).result.then((result) => {
            }, (reason) => {

            });
        }
    }


    searchModal() {

            this.statusSelected = 0;
            this.searchModalReference = this.modalService.open(this.scarch_content);
            this.searchModalReference.result.then((result) => {
            }, (reason) => {

            });
    }


    getDetails() {
        for (let i = 0; i < this.statuses.length; i++) {
            if (this.statuses[i].previd === this.statusSelect) {
                this.nxt = this.statuses[i].nextid;
            }
        }
    }

    search() {
        this._rest.searchAllTicketStatusFlow(this.statusSelect, this.clientId).subscribe((res1) => {
            this.respObject = res1;
            this.isLoading = false;
            if (this.respObject.success) {
                this.statuses = this.respObject.details;
                this.messageService.setTotalData(this.statuses.length);
                this.messageService.setGridData(this.statuses);
                this.searchModalReference.close();

            } else {
                this.notifier.notify('error', this.respObject.errorMessage);
            }
        }, (err) => {
            this.isLoading = false;
            this.notifier.notify('error', this.messageService.SERVER_ERROR);
        });
    }

    save() {
        const seqArray = [];
        for (let i = 0; i < this.selectedstatusValue.length; i++) {
            seqArray.push(this.selectedstatusValue[i].id);
        }
        this.nextStatusSelected = seqArray.toString();
        const data = {
            clientId: this.clientId, ticket_id: this.ticketSelected, previd: this.statusSelected, nextStatus: this.nextStatusSelected
        };
        if (!this.messageService.isBlankField(data)) {
            this._rest.addStatusSeq(data).subscribe((res) => {
                this.respObject = res;
                if (this.respObject.success) {
                    this.isError = false;
                    this.nextOffset = 0;
                    this.page_no = 0;
                    this.getTableData();
                    this.notifier.notify('success', 'Sequence added successfully');
                } else {
                    this.isError = true;
                    this.errorMessage = this.respObject.errorMessage;
                }
            }, (err) => {
                // this.isError = true;
                // this.errorMessage = this.messageService.SERVER_ERROR;
            });
        } else {
            this.isError = true;
            this.errorMessage = this.messageService.BLANK_ERROR_MESSAGE;
        }
    }

    update() {
        const seqArray = [];
        for (let i = 0; i < this.selectedstatusValue.length; i++) {
            seqArray.push(this.selectedstatusValue[i].id);
        }
        this.nextStatusSelected = seqArray.toString();
        const data = {
            id: this.selectedId, clientId: this.clientId, ticket_id: this.ticketSelected, previd: this.statusSelected,
            nextStatus: this.nextStatusSelected, createdBy: this.messageService.getUserId()
        };
        if (!this.messageService.isBlankField(data)) {
            this._rest.updateFlowStatus(data).subscribe((res) => {
                this.respObject = res;
                if (this.respObject.success) {
                    this.isError = false;
                    this.nextOffset = 0;
                    this.page_no = 0;
                    this.getTableData();
                    this.modalReference.close();
                } else {
                    this.isError = true;
                    this.errorMessage = this.respObject.errorMessage;
                }
            }, (err) => {
                this.isError = true;
                this.errorMessage = this.messageService.SERVER_ERROR;
            });
        } else {
            this.isError = true;
            this.errorMessage = this.messageService.BLANK_ERROR_MESSAGE;
        }
    }

    getTableData() {
        // console.log(this.messageService.view)
        if (!this.messageService.view) {
            this.notifier.notify('error', 'You do not have view permission');
        } else {
            this.getData({'offset': this.nextOffset, 'paginationType': ''});
        }
    }

    isEmpty(obj) {
        for (const key in obj) {
            if (obj.hasOwnProperty(key)) {
                return false;
            }
        }
        return true;
    }

    getData(paginationObj) {
        const offset = paginationObj.offset;
        const paginationType = paginationObj.paginationType;
        this.dataLoaded = false;
        this._rest.getstatusSeqData(this.clientId, offset, this.pageSize, paginationType).subscribe((res) => {
            this.respObject = res;
            // console.log("==============="+JSON.stringify(this.respObject));
            this.executeResponse(this.respObject, offset, paginationType);
        }, (err) => {
            this.notifier.notify('error', this.messageService.SERVER_ERROR);
        });
    }

    executeResponse(respObject, offset, paginationType) {
        if (respObject.success) {
            this.dataLoaded = true;
            if (offset === 0) {
                this.totalData = respObject.details.totalData[0].count;
                this.totalPage = respObject.details.totalPage;
                if (this.totalPage === 0) {
                    this.totalPage = 1;
                }
            }
            if (!this.isEmpty(respObject.details.dataObj)) {
                const data = respObject.details.dataObj;
                this.nextOffset = respObject.details.nextOffset;
                this.offset = respObject.details.nextOffset;
                this.previousOffset = respObject.details.previousOffset;
                this.messageService.setTotalData(this.totalData);
                this.messageService.setGridData(data);
                // ----------------------------------------------
                if (offset !== 0) {
                    const totalCount = this.totalData;
                    const divRes = totalCount / this.pageSize;
                    const remainder = totalCount % this.pageSize;
                    if (remainder === 0) {
                        this.totalPage = parseInt(String(divRes), 10);
                    } else {
                        this.totalPage = parseInt(String(divRes), 10) + 1;
                    }
                }
                // ------------------------------------------------
                if (paginationType === 'next') {
                    this.page_no = this.page_no + 1;
                } else if (paginationType === 'prev') {
                    this.page_no = this.page_no - 1;
                } else if (paginationType === '' && this.page_no === 0) {
                    this.page_no = this.page_no + 1;
                }
                if (this.totalData <= this.pageSize * this.page_no) {
                    this.nextOffset = 0;
                }
            } else if (this.isEmpty(respObject.details.dataObj) && paginationType === 'next') {
                this.nextOffset = 0;
            } else if (this.isEmpty(respObject.details.dataObj) && paginationType === 'prev') {
                this.previousOffset = 0;
            } else if (paginationType === '' && this.page_no === 0) {
                this.page_no = this.page_no + 1;
            }
        } else {
            this.notifier.notify('error', respObject.errorMessage);
        }
    }

    onPageSizeChange(value: any) {
        this.page_no = 0;
        this.nextOffset = 0;
        this.pageSize = value;
        this.getData({'offset': this.nextOffset, 'paginationType': ''});
    }

    ngOnDestroy(): void {
        if (this.userAuth) {
            this.userAuth.unsubscribe();
        }
    }

    // onTypeChange(selectedIndex: any) {
    //     this.ticketFieldTicketName = this.types[selectedIndex];
    //     if (Number(this.typeSelected) === 3) {
    //         this.isDropdown = true;
    //     } else {
    //         this.isDropdown = false;
    //     }
    // }

    get selectedstatusValue() {
        return this.statusSeq
            .filter(opt => opt.checked)
            .map(opt => opt);

    }


}